import Card from "@/view/components/Card";
import { Separator } from "@/view/components/ui/separator";
import { Skeleton } from "@/view/components/ui/skeleton";

const RaffleSkeleton = () => {
  return (
    <Card className="flex w-full flex-col gap-4 border bg-transparent p-5">
      <div className="flex items-center gap-4">
        <Skeleton className="h-20 w-20 rounded-lg" />
        <Skeleton className="h-6 w-1/2" />
      </div>
      <Separator />
      <div className="flex w-full items-center justify-between rounded-lg bg-gray-100 px-4 py-5 font-semibold">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-8 w-20 rounded-md bg-primary" />
      </div>
    </Card>
  );
};

export default RaffleSkeleton;
